import React, { Fragment } from 'react'
import { OtherPagesCopm } from './otherPage/OtherPage'
import { handleAboveType } from '../types'
import { pages } from './CONTENT'
interface OtherPagesNameListProps {
  clickable: boolean
  handleAbove: handleAboveType
  audio?: any
  customPages?: any
}
export default function OtherPagesNameList({
  clickable,
  handleAbove,
  audio,
  customPages
}: OtherPagesNameListProps) {
  const array = customPages ? customPages : pages
  return (
    <Fragment>
      {array.map((p: any, i: number) => (
        <OtherPagesCopm
          name={p}
          clickable={clickable}
          handleAbove={handleAbove}
          key={i}
          audio={audio}
        />
      ))}
    </Fragment>
  )
}
